import { render, staticRenderFns } from "./RankUp.vue?vue&type=template&id=745224f5&scoped=true"
import script from "./RankUp.vue?vue&type=script&lang=ts"
export * from "./RankUp.vue?vue&type=script&lang=ts"
import style0 from "./RankUp.vue?vue&type=style&index=0&id=745224f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745224f5",
  null
  
)

export default component.exports